import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-428df36b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "head-bar flex-shrink-0 bg-white p-3 pt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_f_icon = _resolveComponent("f-icon")!
  const _component_side_avatar = _resolveComponent("side-avatar")!
  const _component_search_input = _resolveComponent("search-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isBackVisible)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "back-btn hover:text-primary",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClickBack && _ctx.handleClickBack(...args)))
        }, [
          _createVNode(_component_f_icon, {
            name: "back",
            width: 14,
            height: 24
          })
        ]))
      : (_openBlock(), _createBlock(_component_side_avatar, { key: 1 })),
    _renderSlot(_ctx.$slots, "default", {}, () => [
      _createVNode(_component_search_input, { disabled: _ctx.searchDisabled }, null, 8, ["disabled"])
    ], true)
  ]))
}